import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { NetworkGeneralInfo, NetworkGeneralPatch, ViewerId } from './types';

const BASE = '/api/ref-network-general';
const KEY = ['ref-network-general'];

export function useNetworkGeneral() {
    return useQuery({
        queryKey: KEY,
        queryFn: async () => {
            const res = await fetch(`${BASE}/network`);
            if (!res.ok) throw new Error('Impossible de charger le réseau');
            return (await res.json()) as NetworkGeneralInfo;
        },
    });
}

export function useGeneralOptions() {
    return useQuery({
        queryKey: [...KEY, 'options'],
        queryFn: async () => {
            const res = await fetch(`${BASE}/options`);
            return (await res.json()) as { users: string[]; roles: string[]; contracts: string[]; timezones: string[] };
        },
        staleTime: Infinity,
    });
}

export function useUpdateNetworkGeneral(viewer: ViewerId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (patch: NetworkGeneralPatch) => {
            const res = await fetch(`${BASE}/network`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json', 'X-Viewer': viewer },
                body: JSON.stringify(patch),
            });
            const body = await res.json();
            if (!res.ok) throw new Error(body.detail ?? 'Erreur lors de la soumission');
            return body as NetworkGeneralInfo;
        },
        onSuccess: (data) => qc.setQueryData(KEY, data),
    });
}

export function useResetNetworkGeneral() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async () => (await (await fetch(`${BASE}/reset`, { method: 'POST' })).json()) as NetworkGeneralInfo,
        onSuccess: (data) => qc.setQueryData(KEY, data),
    });
}
